import {
  CoordinatesInterface,
  GroupedLocations,
  LocationInterface
} from 'types';

export const groupLocationsByState = (locations: LocationInterface[]) =>
  locations.reduce((acc: GroupedLocations, location: LocationInterface) => {
    const { province } = location;
    if (!acc[province]) {
      acc[province] = [];
    }
    acc[province].push(location);
    return acc;
  }, {});

const deg2rad = (deg: number) => deg * (Math.PI / 180);

export const getDistanceInMiles = (
  location1: CoordinatesInterface,
  location2: CoordinatesInterface
) => {
  const { latitude: lat1, longitude: lon1 } = location1;
  const { latitude: lat2, longitude: lon2 } = location2;

  const R = 3958.8;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

const isInteger = (num: number) => num % 1 === 0;

export const formatDistance = (distance: number): string => {
  const roundedDistance = Math.round(distance * 2) / 2;

  if (roundedDistance < 0.1) {
    return 'Nearby';
  }

  const long = roundedDistance.toFixed(1);
  const fixedSize = isInteger(Number(long)) ? 0 : 1;
  const unit = roundedDistance === 1 ? 'mile' : 'miles';
  return `${roundedDistance.toFixed(fixedSize)} ${unit}`;
};
